import { LoadingButton } from '@mui/lab';
import { Divider, Typography } from '@mui/material';
import { doc, updateDoc } from 'firebase/firestore';
import React, { useState } from 'react'
import Map, { Marker } from 'react-map-gl';
import { db } from '../../../firebase';

function MapView({id}) {
console.log(id)
    const [marker, setMarker] = useState(id.location ? {lng : id.location.long, lat : id.location.lat}
         : {lat: -15.41597580613962, lng : 28.28086405733302} )
const [loading, setloading] = useState(false)
   
const updateLocation = async () =>{
    setloading(true)
    const userDocRef = doc(db, 'business', id.id);
                
    await updateDoc(userDocRef, {
    location: {lat : marker.lat, long : marker.lng},
    }).then(()=>{
        setloading(false)
    }).catch(()=>{
        setloading(false)
    });
    }

    
    

  return (
    <div  >
    
  <Map
      mapboxAccessToken="pk.eyJ1IjoiY2hpc29tbyIsImEiOiJjbG1oZG43MzQxdmo4M3FxcWNyamJuazg1In0.Qzx7VHsNIxxh-knHPliPWw"
      initialViewState={{
        longitude: marker.lng,
        latitude: marker.lat,
        zoom: 14
      }}
      onClick={(event)=>setMarker(event.lngLat)}
      style={{width: "100%", height:400}}
      mapStyle="mapbox://styles/mapbox/streets-v9"
    >
        {marker ? <Marker longitude={marker.lng} anchor='bottom' latitude={marker.lat} color="red" /> : <Typography>Tap on the marker to set your location</Typography>}
    </Map>
      <Divider  sx={{my:3}}>{id.location ? `${marker.lng} ${marker.lat}` : "Pick your location"}</Divider>
      <br/>
      <LoadingButton loading={loading} onClick={()=>updateLocation()} variant='contained' color='success' >Update Location</LoadingButton>
    </div>
  )
}

export default MapView